var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgBag = function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.667 5v-.833a1.667 1.667 0 0 0-3.333 0v.834zm1.667 0v-.833a3.333 3.333 0 0 0-6.667 0v.834H2.686L1.667 17.5h16.667L17.315 5zm-1.667 1.667v2.5h1.667v-2.5h2.445l.747 9.167H3.475l.747-9.167h2.445v2.5h1.667v-2.5z",
    clipRule: "evenodd"
  })));
};
var Memo = /*#__PURE__*/memo(SvgBag);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTEuNjY3IDV2LS44MzNhMS42NjcgMS42NjcgMCAwIDAtMy4zMzMgMHYuODM0em0xLjY2NyAwdi0uODMzYTMuMzMzIDMuMzMzIDAgMCAwLTYuNjY3IDB2LjgzNEgyLjY4NkwxLjY2NyAxNy41aDE2LjY2N0wxNy4zMTUgNXptLTEuNjY3IDEuNjY3djIuNWgxLjY2N3YtMi41aDIuNDQ1bC43NDcgOS4xNjdIMy40NzVsLjc0Ny05LjE2N2gyLjQ0NXYyLjVoMS42Njd2LTIuNXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";